/*
 * This file is part of glowingblue/orell-thalia-common.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import { extend } from 'flarum/common/extend';
import UserPage from 'flarum/forum/components/UserPage';
import app from 'flarum/forum/app';

export default function () {
	extend(UserPage.prototype, 'oninit', function () {
		// @ts-expect-error -- deliberate single-argument push on a history that is always set by now.
		app.history.push(app.current.get('routeName'));
	});
}
